import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store from "./app/store";
import persistStore from "redux-persist/es/persistStore";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ScrollToTop from "./app/components/UI/ScrollToTop/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(store);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <GoogleReCaptchaProvider
            reCaptchaKey={"6LdnSTYlAAAAAGZyoMtCsi85DWspmCGrSj8kxOjM"}
          >
           <ScrollToTop>
           <App />
           </ScrollToTop>
          </GoogleReCaptchaProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
